"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLeadTimeRangeDisplay = exports.getMinLeadTimeDay = exports.getMaxLeadTimeDay = exports.LeadTimeContent = void 0;
exports.LeadTimeContent = {
  en: {
    days: "day(s)",
    tbd: "TBD"
  },
  es: {
    days: "día(s)",
    tbd: "à déterminer"
  },
  fr: {
    days: "journée(s)",
    tbd: "por determinar"
  }
};

var getMaxLeadTimeDay = function getMaxLeadTimeDay(leadTimeDay) {
  return leadTimeDay === null || leadTimeDay === void 0 ? void 0 : leadTimeDay.reduce(function (prev, current) {
    return (prev === null || prev === void 0 ? void 0 : prev.totalLeadTime) > (current === null || current === void 0 ? void 0 : current.totalLeadTime) ? prev : current;
  }, {});
};

exports.getMaxLeadTimeDay = getMaxLeadTimeDay;

var getMinLeadTimeDay = function getMinLeadTimeDay(leadTimeDay) {
  return leadTimeDay.reduce(function (prev, current) {
    return prev.totalLeadTime < current.totalLeadTime ? prev : current;
  }, {});
};

exports.getMinLeadTimeDay = getMinLeadTimeDay;

var getLeadTimeRangeDisplay = function getLeadTimeRangeDisplay(leadTimeDay, language) {
  var content = exports.LeadTimeContent[language] || exports.LeadTimeContent.en; //if there is no lead time days, return empty string

  if (!leadTimeDay) {
    return content.tbd;
  } //if totalLeadTime is null or zero then return TBD


  if (leadTimeDay.length === 1 && (leadTimeDay[0].totalLeadTime === null || leadTimeDay[0].totalLeadTime === 0)) {
    return content.tbd;
  } //if there is only one and valid lead time day,then return that value


  if (leadTimeDay.length === 1) {
    return "".concat(leadTimeDay[0].totalLeadTime, " days");
  }

  var maxLeadTimeDay = (0, exports.getMaxLeadTimeDay)(leadTimeDay);
  var minLeadTimeDay = (0, exports.getMinLeadTimeDay)(leadTimeDay); //if the min and max lead time days are  zero, return TBD

  if (minLeadTimeDay.totalLeadTime === 0 && maxLeadTimeDay.totalLeadTime === 0) {
    return content.tbd;
  } //if the min lead time days is zero,then return max date and tbd


  if (minLeadTimeDay.totalLeadTime === 0) {
    return "".concat(maxLeadTimeDay.totalLeadTime, " days - ").concat(content.tbd);
  } //if the min and max lead time days are the same,then return that value


  if (maxLeadTimeDay.totalLeadTime === minLeadTimeDay.totalLeadTime) {
    return "".concat(maxLeadTimeDay.totalLeadTime, " days");
  }

  return "".concat(minLeadTimeDay.totalLeadTime, "-").concat(maxLeadTimeDay.totalLeadTime, " days");
};

exports.getLeadTimeRangeDisplay = getLeadTimeRangeDisplay;